import { ComponentsProps, ComponentsOverrides, ComponentsVariants, backdropClasses } from '@mui/material';
import { Theme } from '@mui/system/createTheme';

export const MuiBackdrop: {
    defaultProps?: ComponentsProps['MuiBackdrop'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiBackdrop'];
    variants?: ComponentsVariants['MuiBackdrop'];
} = {
    styleOverrides: {
        root: (props) => ({
            [`:not(.${backdropClasses.invisible})`]: {
                backgroundColor: props.theme.palette.components.backdrop.bgcolor,
            },
        }),
    },
};
